import { AnalyticsEventTopic, getOafIdFromEvent } from '~/modules/analytics/analyticsHelper';
import { Routes } from '~/modules/routes';
import { selectIsGuestUser, userStore } from '~/modules/stores/userStore';
import { AnalyticsWeightings } from '../analyticsWeightings';
import { CoveoAnalyticsCustomData, CoveoAnalyticsEvent, CoveoEventType } from './coveoEventType';

interface PageViewCoveoAnalyticsCustomData extends CoveoAnalyticsCustomData {
    actionCause: string;
    listingCategoryName?: string;
}

interface PageViewCoveoAnalyticsEvent extends CoveoAnalyticsEvent {
    contentType: string;
    contentIdValue: string;
    contentIdKey: string;
    location: string;
    customData: PageViewCoveoAnalyticsCustomData;
}

export class PageViewCoveoEventType extends CoveoEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_PAGE_LOAD && event.coveo?.eventAction === 'appxListingDetail'
        );
    }

    // @ts-expect-error * Automated Type Error Fix
    getBody(event): PageViewCoveoAnalyticsEvent {
        const baseEvent = this.baseBody(event);
        const oafId = getOafIdFromEvent(event);
        return {
            ...baseEvent,
            outcome: AnalyticsWeightings.pageViewPoints,
            contentType: 'Listing__c',
            contentIdValue: oafId,
            contentIdKey: 'permanentId',
            location: `https://appexchange.salesforce.com/${Routes.LISTING}?listingId=` + oafId,
            customData: {
                ...baseEvent.customData,
                ...this.getListingCategory(event),
                actionCause: 'listingDetail',
            },
        };
    }

    // @ts-expect-error * Automated Type Error Fix
    getListingCategory(event) {
        return selectIsGuestUser(userStore.getState()) ? { listingCategoryName: event.listingCategoryName } : {};
    }

    getPath(): string {
        return 'view';
    }
}
